const UNITS: readonly string[] = ['B', 'KB', 'MB', 'GB'];

export const formatBytes = (bytes: number): string => {
  if (bytes < 0 || !Number.isFinite(bytes)) {
    throw new RangeError(`Cannot format byte count ${bytes}`);
  }
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  const digits = unitIndex === 0 ? 0 : value < 10 ? 2 : 1;
  return `${value.toFixed(digits)} ${UNITS[unitIndex]}`;
};

export const formatPercent = (done: number, total: number): string => {
  if (total <= 0) {
    return '0%';
  }
  return `${Math.min(100, Math.floor((done / total) * 100))}%`;
};

/** Average throughput since the transfer started, in bytes per second. */
export const throughput = (bytes: number, startedAtMs: number, nowMs: number): number => {
  const elapsedSeconds = (nowMs - startedAtMs) / 1000;
  if (elapsedSeconds <= 0) {
    return 0;
  }
  return bytes / elapsedSeconds;
};

export const formatSpeed = (bytesPerSecond: number): string => `${formatBytes(bytesPerSecond)}/s`;

export const formatEta = (remainingBytes: number, bytesPerSecond: number): string => {
  if (bytesPerSecond <= 0) {
    return '--';
  }
  const seconds = Math.ceil(remainingBytes / bytesPerSecond);
  if (seconds < 60) {
    return `${seconds}s`;
  }
  const minutes = Math.floor(seconds / 60);
  return `${minutes}m ${seconds % 60}s`;
};

/** Groups a numeric PIN into blocks of three digits for readability: 123456789 -> "123 456 789". */
export const formatPin = (pin: string): string => pin.replace(/(\d{3})(?=\d)/g, '$1 ');

/** Strips everything but digits from user input so a formatted PIN can be pasted back. */
export const normalizePinInput = (raw: string): string => raw.replace(/\D/g, '');
